module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/20161231/sp_menu_reserving-0f8898a224427e37f60d213b1052bf13.png";